<div *ngIf="clientData && !isLoading" style="min-height: 85vh;">

  <div class="card">
    <div class="card-header" *ngIf="clientData != null">
      <h2 class="card-title">{{ clientData.name }}</h2>
      <button class="custom-button add-button" style="float: right;" (click)="showDialogDeleteApp(dialogDeleteApp)"
        translate>customer.deleteClient<i class="fa fa-trash ml-2"></i></button>
    </div>

    <app-client-admins [clientId]="clientData.id" [darkMode]="darkMode"></app-client-admins>

    <div class="card-body">

      <div class="card client-info-card">
        <div class="client-info-header">
          <div class="client-header-text">
            <h4 class="client-info-name">{{clientData?.name}}</h4>
            <p class="client-info-desc" *ngIf="clientData?.description">{{clientData?.description}}</p>
            <span class="client-info-customer" *ngIf="customersData != null">
              <i class="fa fa-link mr-1"></i> {{getCustomer(clientData?.customerId).name}}
            </span>
          </div>
          <button class="btn-add-credit" (click)="toggleAddClientCredit = true;">
            <i class="fa fa-plus-circle"></i> <span translate>customer.addCredit</span>
          </button>
        </div>

        <div class="client-info-grid">
          <div class="client-info-item">
            <div>
              <span class="info-label" translate>customer.country</span>
              <span class="info-value">{{clientData.country || '/'}}</span>
            </div>
          </div>
          <div class="client-info-item">
            <div>
              <span class="info-label" translate>customer.city</span>
              <span class="info-value">{{clientData.city || '/'}}</span>
            </div>
          </div>
          <div class="client-info-item">
            <div>
              <span class="info-label" translate>customer.address</span>
              <span class="info-value">{{clientData.address || '/'}}</span>
            </div>
          </div>
          <div class="client-info-item">
            <div>
              <span class="info-label" translate>customer.postCode</span>
              <span class="info-value">{{clientData.postCode || '/'}}</span>
            </div>
          </div>
        </div>

        <div class="client-info-note" *ngIf="clientData.notes && clientData.notes !== ''">
          <i class="fa fa-sticky-note mr-2"></i>
          <span>{{clientData.notes}}</span>
        </div>

        <div class="client-info-footer">
          <div class="credits-section">
            <div class="credit-badge">
              <i class="fa fa-coins"></i>
              <div>
                <span class="credit-label" translate>customer.credits</span>
                <span class="credit-value">{{clientData?.credits || 0}}</span>
              </div>
            </div>
            <div class="credit-badge premium">
              <i class="fa fa-star"></i>
              <div>
                <span class="credit-label" translate>customer.premiumCredits</span>
                <span class="credit-value">{{clientData?.premiumCredits || 0}}</span>
              </div>
            </div>
          </div>
          <div class="client-info-actions">
            <a class="invoice-link" (click)="navigateToInvoices()">
              <i class="fa fa-file-text mr-1"></i> <span translate>invoice.invoices</span>
            </a>
            <a *ngIf="customersData != null" class="change-customer-link" (click)="onChangeCustomer()">
              <i class="fa fa-exchange mr-1"></i> Change Customer
            </a>
          </div>
        </div>
      </div>

      <!-- presets -->
      <app-profile-presets-list (addItem)="addPreset($event)" (deletePresetItem)="deletePreset($event)"
        [secondProfilesOnThePage]="secondProfilesOnThePage" [darkMode]="darkMode" [title]="'client.clientPresets'"
        [noDataMsg]="'customer.customerNoAssignedPresets'" [canUseConfigurator]="customer?.fillableImageEnabled" [canUseScalingConfigurator]='true' [canUsePremiumTargets]="clientData?.usePremium" [clientId]="clientData.id"></app-profile-presets-list>

      <!-- frames -->
      <app-frames-list [role]="'client'" [clientId]="clientData.id" [customerId]="clientData.customerId" [darkMode]="darkMode"></app-frames-list>
      
      <app-license-plates-list [role]="'client'" [clientId]="clientData.id" [customerId]="clientData.customerId" [darkMode]="darkMode"></app-license-plates-list>

      <app-logos-list [role]="'client'" [clientId]="clientData.id" [customerId]="clientData.customerId" [darkMode]="darkMode"></app-logos-list>

      <!-- backgrounds -->
      <app-profile-backgrounds-list (addItem)="addBackground($event)" (deleteBgFile)="deleteBackground($event)"
        [secondProfilesOnThePage]="secondProfilesOnThePage" [darkMode]="darkMode"></app-profile-backgrounds-list>


      <div class="col-lg-12 col-md-12 col-sm-12 card"
        *ngIf="currentUser.role.name === 'root' &&  applicationBgs != null">
        <div class="card-header">
          <h3 class="card-title">Old Application Backgrounds</h3>
          <button type="button" class="custom-button add-button" style="float: right;"
            (click)="toggleAddBackground = !toggleAddBackground">Add
            Background</button>
        </div>
        <div class="row">
          <div *ngIf="applicationBgs && !applicationBgs.length" style="min-height: 60px;">
            <p class="no-data-message">No old backgrounds assigned.</p>
          </div>
          <div class="col-lg-4 col-sm-6" *ngFor="let bg of applicationBgs; let index = index">
            <div class="root-application-bg-container ">
              <div class="root-application-image-delete" (click)="showDialogDeleteFile(dialogDeleteFile, bg)"></div>
              <div class="root-application-bg" [style.background-image]="'url(' + bg.fileInfo.path + ')'"></div>
              <div class="root-application-filename"> {{bg.fileInfo.filename}}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- CUSTOMER & CLIENT FEATURES ROOT -->
      <div class="col-lg-12 col-md-12 col-sm-12 card" [class.dark-mode]="darkMode">
        <div class="card-header">
          <h3 *ngIf="currentUser.role.name === 'root'" class="card-title" translate>Features Custom Price</h3>
          <h3 *ngIf="currentUser.role.name !== 'root'" class="card-title" translate>settings.featuresPrice</h3>
          <button *ngIf="currentUser.role.name === 'root'" type="button" class="custom-button add-button"
            style="float: right;" (click)="toggleFeaturePrice = true">New Feature Price<i class="fa fa-plus"
              style="margin-left: 7px;"></i></button>
        </div>
        <div style="padding: 0.75rem 1.25rem;">
          <div *ngIf="clientFeatures && !clientFeatures.length" style="min-height: 60px;">
            <p class="no-data-message" translate>No features.</p>
          </div>
          <p *ngIf="clientFeatures && clientFeatures.length">
            <button class="custom-button btn-red" type="button" data-toggle="collapse" data-target="#collapseExample"
              aria-expanded="false" aria-controls="collapseExample" translate>settings.seePrices</button>
          </p>
          <div class="collapse price_container" id="collapseExample">
            <div class="d-flex justify-content-between my-2 px-2 feature_price"
              *ngFor="let feature of clientFeatures; let index = index">
              <p *ngIf="currentUser.role.name === 'root'" style="flex: 1">{{feature.feature.displayName}}</p>
              <p *ngIf="currentUser.role.name !== 'root'" style="flex: 1">{{feature.displayName}}</p>
              <p style="flex: 1" class="text-center">Price: {{feature.price}}</p>
              <div *ngIf="currentUser.role.name === 'root'" style="flex: 1" class="edit-webhook">
                <button class="edit-button" (click)="onEditPrice(feature)" translate>global.edit</button>
                <button class="delete-button" (click)="deletePrice(feature)" translate>global.delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CUSTOMER & CLIENT FEATURES CUSTOMER 
      <div *ngIf="currentUser.role.name === 'customer'" class="col-lg-12 col-md-12 col-sm-12 card"
        [class.dark-mode]="darkMode">
        <div class="card-header">
          <h3 class="card-title" translate>Features Price</h3>
        </div>
        <div style="padding: 0.75rem 1.25rem;">
          <div *ngIf="clientFeatures && !clientFeatures.length" style="min-height: 60px;">
            <p class="no-data-message" translate>No features.</p>
          </div>
          <div class="d-flex justify-content-between my-2" *ngFor="let feature of clientFeatures; let index = index">
            <p style="flex: 1">{{feature.displayName}}</p>
            <p style="flex: 1" class="text-center">Price: {{feature.price}}</p>
          </div>
        </div>
      </div>-->

      <div *ngIf="currentUser.role.name === 'root'" class="col-lg-12 col-md-12 col-sm-12 card">
        <div class="card-header">
          <h3>Quality Check Priority</h3>
        </div>
        <div class="row p-3">
          <div class="choose-window d-flex">
            <input type="number" class="form-control" placeholder="Priority" name="priority"
              [(ngModel)]="clientData.priority">
            <button class="custom-button ml-3" (click)="updateClient('priority', clientData.priority)">SAVE</button>
          </div>
        </div>
      </div>

      <div *ngIf="currentUser.role.name === 'root'" class="col-lg-12 col-md-12 col-sm-12 card">
        <div class="card-header">
          <h3>Image Resolution</h3>
        </div>
        <div class="row p-3">
          <div class="choose-window d-flex">
            <input type="text" class="form-control" placeholder="1920x1440" name="outputImageResolution"
              [(ngModel)]="clientData.outputImageResolution">
            <button class="custom-button ml-3"
              (click)="updateClient('outputImageResolution', clientData.outputImageResolution)">SAVE</button>
          </div>
        </div>
      </div>

      <app-general-settings-item [darkBg]="darkMode" *ngIf="['root', 'customer'].includes(currentUser.role.name) && customer?.interiorBackgroundEnabled" [icon]="" [title]="'settings.interiorBg'"
        [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.interiorBackgroundEnabled'
          (select)="switchInteriorBg($event)" [userCheck]="true"></app-general-settings-checkbox>
      </app-general-settings-item>

      <app-general-settings-item *ngIf="['root'].includes(currentUser.role.name)" [icon]="" [title]="'Shadow Type'"
        [userChecks]="true">
        <app-general-settings-select mySelect [disabled]="currentUser.role.name !== 'root'" [currentUser]='currentUser'
          [defaultSelect]='clientData.shadowType' [options]='shadowType' (select)='changeLegacyChadow($event)'>
        </app-general-settings-select>
      </app-general-settings-item>

      <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'Remove Reflections'"
        [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.removeReflectionsEnabled'
          (select)="switchRemoveReflections($event)" [userCheck]="true"></app-general-settings-checkbox>
      </app-general-settings-item>

      <app-general-settings-item [darkBg]="darkMode" *ngIf="['root', 'customer'].includes(currentUser.role.name) && customer?.preprocessingEnabled" [icon]="" [title]="'Preprocessing'"
        [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.preprocessingEnabled'
          (select)="switchPreprocessing($event)" [userCheck]="true"></app-general-settings-checkbox>
      </app-general-settings-item>

      <!-- Vehicle Types -->
      <div *ngIf="currentUser.role.name === 'root'" class="col-lg-12 col-md-12 col-sm-12 card">
        <div class="card-header">
          <h3 class="card-title" translate>Vehicle Types</h3>
          <button *ngIf="currentUser.role.name === 'root'" type="button" class="custom-button add-button"
            style="float: right;" (click)="toggleVehicleType = true">New Vehicle Type<i class="fa fa-plus"
              style="margin-left: 7px;"></i></button>
        </div>
        <div *ngIf="vehicleTypes && vehicleTypes.length" class="row p-3">
          <div class="d-flex justify-content-between my-2 px-2 feature_price w-100"
            *ngFor="let type of vehicleTypes; let index = index">
            <p style="flex: 1">{{type.label}}</p>
            <div *ngIf="currentUser.role.name === 'root'" style="flex: 1" class="edit-webhook">
              <button class="edit-button" (click)="onEditType(type)" translate>global.edit</button>
              <button class="delete-button" (click)="deleteVehicleType(type)" translate>global.delete</button>
            </div>
          </div>
        </div>
      </div>
      <!-- /Vehicle Types -->

      <!-- DMS -->
      <div class="col-lg-12 col-md-12 col-sm-12 card" [class.dark-mode]="darkMode">
        <div class="card-header">
          <h3 class="card-title" translate>settings.clientDms</h3>
        </div>
        <app-interface-setup [clientId]="clientData.id" [isClientDms]="true"
          [currentUser]="currentUser"></app-interface-setup>
      </div>
      <!-- /DMS -->

      <!-- Credit notifications -->
      <div *ngIf="clientSettings" class="col-lg-12 col-md-12 col-sm-12 card" [class.dark-mode]="darkMode">
        <div class="card-header">
          <h3 class="card-title" translate>settings.creditNotify</h3>
        </div>
        <div class="d-flex justify-content-between my-4 px-3 align-items-center">
          <div class="w-100">
            <p translate>settings.creditNotification</p>
          </div>
          <div style="position: relative;" class="row">
            <div class="choose-window">
              <p translate>global.off</p>
              <label class="switch">
                <input type="checkbox" (change)="patchCreditsNotification($event)" name="creditsNotificationEnabled"
                  [ngModel]="clientSettings.creditsNotificationEnabled">
                <span class="slider round"></span>
              </label>
              <p translate>global.on</p>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mb-4 px-3">
          <p translate>settings.creditLimit</p>
          <div class="d-flex">
            <input type="number" class="form-control" name="creditsNotificationThreshold"
              [(ngModel)]="clientSettings.creditsNotificationThreshold">
            <button class="custom-button" style="margin-left: 10px; width: 40%;" (click)="updateTreshold()"
              translate>global.save</button>
          </div>
        </div>
      </div>

      <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'Postponed Invoice'"
        [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.postponedInvoiceEnabled'
          (select)="switchPostInvoice($event)" [userCheck]="true"></app-general-settings-checkbox>
      </app-general-settings-item>

      <app-general-settings-item *ngIf="currentUser.role.name === 'root' && customer?.duplicateVehicleEnabled" [icon]=""
        [title]="'Duplicate car'" [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.duplicateVehicleEnabled'
          (select)="switchDuplicateCar($event)" [userCheck]="true"></app-general-settings-checkbox>
      </app-general-settings-item>

      <app-general-settings-item *ngIf="currentUser.role.name === 'root' && customer?.usePremium" [icon]=""
        [title]="'Use Premium'" [userChecks]="true" [isNew]="true" [newUntil]="'2026-03-01'">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.usePremium'
          (select)="updateSetting($event, 'usePremium')" [userCheck]="true"></app-general-settings-checkbox>
      </app-general-settings-item>

      <app-general-settings-item *ngIf="currentUser.role.name === 'root' && customer?.markersEnabled" [icon]="" [title]="'Markers'"
        [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.markersEnabled'
          (select)="updateSetting($event, 'markersEnabled')" [userCheck]="true"></app-general-settings-checkbox>
      </app-general-settings-item>

      <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [title]="'Deactivate Account'"
        [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.deactiveAccountEnabled'
          (select)="updateSetting($event, 'deactiveAccountEnabled')" [userCheck]="true">
        </app-general-settings-checkbox>
      </app-general-settings-item>

      <app-general-settings-item *ngIf="['root', 'customer'].includes(currentUser.role.name) && customer?.licensePlateNumberEnabled" [title]="'License Plate Required'"
        [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.licensePlateNumberRequired'
          (select)="updateSetting($event, 'licensePlateNumberRequired')" [userCheck]="true">
        </app-general-settings-checkbox>
      </app-general-settings-item>

      <div *ngIf="['root'].includes(currentUser.role.name)"
        class="d-flex justify-content-between mb-3 settings-item bg-white border-bottom">
        <div class="w-100 d-flex align-items-center">
          <h3>Glass Blur Coefficient</h3>
        </div>
        <div class="choose-window" style="width: 300px;">
          <input type="text" class="form-control" placeholder="Glass Blur Coefficient" name="clientData?.glassBlurCoefficient" [(ngModel)]="clientData.glassBlurCoefficient">
          <button class="custom-button ml-3" (click)="updateClient('glassBlurCoefficient', clientData.glassBlurCoefficient)">SAVE</button>
        </div>
      </div>

      <app-general-settings-item *ngIf="['root'].includes(currentUser.role.name)" [title]="'vehicles.additionalVehicleFields'"
        [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.additionalVehicleFieldsEnabled'
          (select)="updateSetting($event, 'additionalVehicleFieldsEnabled')" [userCheck]="true">
        </app-general-settings-checkbox>
      </app-general-settings-item>

      <app-general-settings-item *ngIf="currentUser.role.name === 'root' && customer?.automaticVinDecodeEnabled" [title]="'Vin Decode'"
        [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.automaticVinDecodeEnabled'
          (select)="updateSetting($event, 'automaticVinDecodeEnabled')" [userCheck]="true">
        </app-general-settings-checkbox>
      </app-general-settings-item>

      <!-- Three Sixty Video Duration -->
      <div *ngIf="clientSettings && customer?.threeSixtyVideo" class="col-lg-12 col-md-12 col-sm-12 card" [class.dark-mode]="darkMode">
        <div class="card-header">
          <h3 class="card-title" translate>settings.videoDuration</h3>
        </div>
        <div class="d-flex justify-content-between my-4 px-3">
          <div class="d-flex">
            <input type="number" class="form-control" name="threeSixtyVideoDuration"
              [(ngModel)]="clientSettings.threeSixtyVideoDuration">
            <button class="custom-button" style="margin-left: 10px; width: 40%;" (click)="updateThreeSixtyVideoDuration()"
              translate>global.save</button>
          </div>
        </div>
      </div>

      <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [title]="'Quality Check'"
        [userChecks]="true">
        <app-general-settings-checkbox mySelect [defaultChecked]='clientData?.qcEnabled'
          (select)="updateSetting($event, 'qcEnabled')" [userCheck]="true">
        </app-general-settings-checkbox>
      </app-general-settings-item>

      <!-- Settings -->
      <div class="col-lg-12 col-md-12 col-sm-12 card pb-3" [class.dark-mode]="darkMode">
        <div *ngIf="currentUser && clientSettings" class="form-container w-100">
          <div class="d-flex justify-content-between m-2">
            <p translate>settings.userSettingsMode</p>
            <div>
              <select class="form-control" (change)="updateSettingsMode($event)" name="userSettingsMode"
                [ngModel]="clientSettings.userSettingsMode" id="">
                <option value="user">User</option>
                <option value="client">Client</option>
                <option value="userReadOnly">User Read Only</option>
              </select>
            </div>
          </div>

          <div *ngIf="clientSettings.userSettingsMode === 'client'" style="min-height: 500px; padding: 12px;"
            id="settings" class="tab-pane active"><br>
            <div class="mb-3 ml-3 font-weight-bold" translate>settings.background</div>

            <app-general-settings-item *ngIf="clientData?.interiorBackgroundEnabled" [icon]="'fa-crop'"
              [title]="'user.cropInteriorType'" [darkBgMode]="darkMode">
              <app-general-settings-select mySelect [disabled]="currentUser?.readOnlyPermissions"
                [currentUser]='currentUser' [defaultSelect]='clientSettings?.cropTypeInterior'
                [options]='interiorCropOptions' (select)='patchInteriorCropType($event)'>
              </app-general-settings-select>
            </app-general-settings-item>

            <div class="d-flex justify-content-between align-items-center mb-3 settings-item"
              [class.settings-item-dark]="darkMode">
              <p translate><i class="fa fa-picture-o mr-3" style="font-size: 1.5rem;color: gray" aria-hidden="true"></i>settings.bgSetup</p>
              <button (click)="openBgSetupModal()" class="custom-button px-5 py-2" translate>settings.bgSetup</button>
            </div>

            <app-general-settings-item [icon]="'fa-crosshairs'" [title]="'user.logoPosition'" [darkBgMode]="darkMode">
              <app-general-settings-select mySelect [disabled]="currentUser?.readOnlyPermissions"
                [currentUser]='currentUser' [defaultSelect]='clientSettings?.logoPosition'
                [options]='logoPositionOptions' (select)='patchLogoPosition($event)'>
              </app-general-settings-select>
            </app-general-settings-item>

            <app-general-settings-item [title]="'user.blur'" [darkBgMode]="darkMode">
              <app-general-settings-select mySelect [disabled]="currentUser?.readOnlyPermissions"
                [currentUser]='currentUser' [defaultSelect]='clientSettings?.blurAmount' [options]='blurOptions'
                (select)='patchBlur($event)'>
              </app-general-settings-select>
            </app-general-settings-item>

            <div class="mb-3 ml-3 font-weight-bold" translate>settings.processing</div>
            <app-general-settings-item [icon]="'fa-chart-area'" [title]="'user.defaultPreset'" [darkBgMode]="darkMode">
              <app-general-settings-select mySelect [disabled]="currentUser?.readOnlyPermissions"
                [currentUser]='currentUser' [defaultSelect]='clientSettings?.defaultPreset' [options]='presetsList'
                (select)='patchPreset($event)' [processing]='true' [userSettings]="clientSettings">
              </app-general-settings-select>
            </app-general-settings-item>

            <app-settings-features [features]='features' [currentUser]='currentUser'
              (sendFeature)='patchFeature($event)' (message)='showMessage($event)'
              [panoramaEnabled]='customer?.panoramaEnabled' [darkBgMode]="darkMode" [markersEnabled]="clientData?.markersEnabled" [isClientFeatures]="true" [clientId]="clientData?.id" [client]="clientData">
            </app-settings-features>

            <app-general-settings-item [imgSrc]="'../../../../assets/img/plates-icon.svg'"
              [title]="'customer.defaultLicensePlate'" [darkBgMode]="darkMode">
              <app-general-settings-select-image mySelect
                [img]="(clientSettings?.previewLicensePlate != null) ? clientSettings?.previewLicensePlate?.file.path : 'assets/img/no-image.png'"
                (selectBg)='openPatchLicensePlate()'>
              </app-general-settings-select-image>
            </app-general-settings-item>

            <app-general-settings-item *ngIf="clientData?.qcEnabled" [title]="'user.qc'" [icon]="'fa-check'" [darkBgMode]="darkMode">
              <app-general-settings-checkbox mySelect [defaultChecked]='clientSettings?.qualityCheck'
                [disabled]="currentUser?.readOnlyPermissions" (select)='patchQC($event)'>
              </app-general-settings-checkbox>
            </app-general-settings-item>

            <app-general-settings-item [icon]="'fa-camera'" [title]="'user.cameraLabelsSensitivity'"
              [darkBgMode]="darkMode">
              <app-general-settings-select mySelect [disabled]="currentUser?.readOnlyPermissions"
                [currentUser]='currentUser' [options]='cameraLibelaSensitivity'
                (select)='patchCameraSensitivity($event)' [userSettings]="clientSettings"
                [defaultSelect]='clientSettings?.cameraLibelaSensitivity'>
              </app-general-settings-select>
            </app-general-settings-item>
          </div>
        </div>
      </div>

      <!-- All Users -->

      <div #users id="users" class="all-users">
        <div class="d-flex align-items-center">
          <h3 class="card-title" translate>customer.users</h3>
        </div>

        <div class="d-flex search-container">
          <div class="search-text d-flex">
            <input type="text" class="search" [(ngModel)]="searchParam" (keydown.enter)="applyFilter()"
              [attr.placeholder]="'global.searchUserNameOrEmail' | translate">
            <div class="d-flex" style="flex-direction: row; align-items: center;">
              <span class="exit" (click)="clearUSerSearch()"></span>
              <span class="line"></span>
            </div>
          </div>
          <span class="search-icon" (click)="applyFilter()"><i class="fa fa-search"></i></span>
        </div>

        <div class="d-flex align-items-center flex-row justify-content-end">
          <button type="button" class="custom-button add-button" (click)="openAddUserModal()"
            translate>customer.newUser<i class="fa fa-plus ml-1" style="margin-left: 7px;"></i>
          </button>
        </div>
      </div>

      <div style="padding: 10.5px 17.5px;">
        <div class="form-group" style="max-width: 150px;">
          <label for="sort">Sort by:</label>
          <select name="sort" id="sort" class="form-control" (change)="handleSortUsers($event)">
            <option value="lastOnline" selected>Last Online</option>
            <option value="name">Name</option>
          </select>
        </div>

        <h5 style="font-weight: bold;">Filters</h5>
        <div class="form-group">
          <label>Last Online status:</label>
          <div class="d-flex" style="gap: 10px">
            <div *ngFor="let option of filterOptions">
              <input 
                type="checkbox" 
                [checked]="selectedFilter === option.value" 
                (change)="selectFilter(selectedFilter === option.value ? null : option.value)">
      
                {{ option.label }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="usersDataSearch && usersDataSearch.length" class="card-body" style="min-height: 300px;">
        <div class="row users">
          <app-user-item
            *ngFor="let user of usersDataSearch | slice: (page-1) * perPage : (page-1) * perPage + perPage; trackBy: trackByMethod"
            [user]="user" [applications]="applicationsAll" (goToUser)="navigateToUser($event)"
            (deleteUser)="deleteUser($event)" (reloadUser)="reloadUserData($event)" class="col-lg-4 col-md-6 col-sm-12">
          </app-user-item>
        </div>
        <div class="clearfix" style="width: 100%"></div>
        <ngb-pagination [collectionSize]="usersDataSearch.length" [(pageSize)]="perPage" [(page)]="page" [maxSize]="5"
          [rotate]="true" (pageChange)="jumpToPage($event)"></ngb-pagination>
      </div>

    </div>

  </div>
</div>

<!-- Modal Form Delete Application File -->
<ng-template #dialogDeleteFile let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Attempt to delete the file!</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <p>Are you sure you want to delete the file?</p>
      <div class="image-delete-thumb" [style.background-image]="'url(' + fileToDelete?.fileInfo.path + ')'"></div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteFile()">YES</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')">NO</button>
  </div>
</ng-template>

<!-- Modal Form Delete Application -->
<ng-template #dialogDeleteApp let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title red-text">WARNING !</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <p>Are you sure you want to delete the application?</p>
      <p style="font-weight: bold;">All users linked with this application will also be deleted.</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteApp()">YES</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')">NO</button>
  </div>
</ng-template>

<!-- Bg Setup -->
<app-background-setup #dialogBgSetup [settings]="clientSettings" [backgrounds]="newBackgrounds"
  [backgroundFiles]="backgroundFiles" (onSaveBgSetup)="SaveBgSetup($event)"></app-background-setup>

<!-- Add Client Credit -->
<app-modal (close)="toggleAddClientCredit = !toggleAddClientCredit" *ngIf="toggleAddClientCredit">
  <div class="modal_container black-text">
    <div class="modal-header">
      <h4 class="modal-title" translate>customer.addCreditHeader</h4>
    </div>
    <div class="modal-body">
      <form #userCreditForm="ngForm" (ngSubmit)="sendClientCredit(userCreditForm)" class="form-vehicle">
        <!-- Credit Type -->
        <div class="form-group">
          <label for="" translate>customer.creditType</label>
          <select class="form-control" name="creditType" ngModel="credits">
            <option value="credits">Credits</option>
            <option value="premiumCredits" [disabled]="!clientData?.usePremium">Premium Credits</option>
          </select>
        </div>
        <!-- Credit -->
        <div class="form-group">
          <label for="" translate>customer.credit</label>
          <input type="number" name="credit" ngModel class="form-control">
        </div>
        <button type="submit" class="form-control btn btn-block custom-button btn-transparent"
          translate>customer.add</button>
      </form>
    </div>
  </div>
</app-modal>

<!-- Add License Plate -->
<app-modal (close)="toggleAddLicensePlate = !toggleAddLicensePlate" *ngIf="toggleAddLicensePlate">
  <div class="modal_container black-text">
    <p class="text-header-modal">New Lince Plate</p>

    <form #licensePlateForm="ngForm" (ngSubmit)="addLicensePlate(licensePlateForm)" class="form-vehicle">
      <!-- Name -->
      <div class="form-group">
        <label translate>global.name</label>
        <input type="text" #name="ngModel" autocomplete="off" required ngModel class="form-control"
          [class.is-invalid]="name.invalid && name.touched" name="name">
      </div>
      <div class="form-group">
        <input type="file" name="image" ngModel (change)="getlicensePlateFile($event)" placeholder="Choose Image" />
        <div class="bg-files bg-hover" style="background-size: contain;" *ngIf="previewImage != null"
          [style.background-image]="'url(' + previewImage + ')'"></div>
      </div>
      <div style="min-height: 24px;"></div>
      <button type="submit" class="custom-button" style="width: 120px;">SAVE</button>
    </form>
  </div>
</app-modal>

<!-- ADD FEATURE PRICE -->
<app-modal (close)="toggleFeaturePrice = !toggleFeaturePrice" *ngIf="toggleFeaturePrice">
  <div class="modal_container black-text">
    <p class="text-header-modal">New Feature Price</p>
    <form #featureForm="ngForm" (ngSubmit)="addFeaturePrice(featureForm)" class="form-vehicle">
      <div class="form-group">
        <select class="form-control" name="featureId" ngModel>
          <option value="" disabled selected>Select Feature</option>
          <option *ngFor="let feature of features" value="{{feature.id}}">{{feature.displayName}}</option>
        </select>
      </div>
      <input placeholder="Price" type="number" name="price" ngModel class="form-control" required>
      <div style="min-height: 24px;"></div>
      <button type="submit" class="custom-button" style="width: 120px;">SAVE</button>
    </form>
  </div>
</app-modal>

<!-- EDIT FEATURE PRICE -->
<app-modal (close)="togglePrice = !togglePrice" *ngIf="togglePrice">
  <div class="modal_container black-text">
    <p class="text-header-modal">Edit Feature Price</p>
    <form #featureForm="ngForm" (ngSubmit)="editPrice(featureForm)" class="form-vehicle">
      <p>{{editFeaturePrice.displayName}}</p>
      <input placeholder="Price" type="number" name="price" [ngModel]="editFeaturePrice.price" class="form-control"
        required>
      <div style="min-height: 24px;"></div>
      <button type="submit" class="custom-button" style="width: 120px;">SAVE</button>
    </form>
  </div>
</app-modal>

<!-- Vehicle Type -->
<app-modal (close)="toggleVehicleType = !toggleVehicleType" *ngIf="toggleVehicleType">
  <div class="modal_container black-text">
    <p class="text-header-modal">New Vehicle Type</p>
    <form #vehicleType="ngForm" (ngSubmit)="addVehicleType(vehicleType)" class="form-vehicle">
      <input placeholder="Name" type="text" name="name" ngModel class="form-control mb-2" required>
      <input placeholder="Label" type="text" name="label" ngModel class="form-control" required>
      <div style="min-height: 24px;"></div>
      <button type="submit" class="custom-button" style="width: 120px;">SAVE</button>
    </form>
  </div>
</app-modal>

<app-modal (close)="toggleEditVehicleType = !toggleEditVehicleType" *ngIf="toggleEditVehicleType">
  <div class="modal_container black-text">
    <p class="text-header-modal">Edit Vehicle Type</p>
    <form #editVehicleTypeForm="ngForm" (ngSubmit)="editVehicleType(editVehicleTypeForm)" class="form-vehicle">
      <input placeholder="Name" type="text" name="name" [ngModel]="editType.name" class="form-control mb-2" required>
      <input placeholder="Label" type="text" name="label" [ngModel]="editType.label" class="form-control" required>
      <div style="min-height: 24px;"></div>
      <button type="submit" class="custom-button" style="width: 120px;">SAVE</button>
    </form>
  </div>
</app-modal>

<!-- Modal license plates -->
<ng-template #dialogDefaultPlate let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>customer.defaultLicensePlate</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex" style="flex-wrap: wrap;">
      <div class="m-3 p-3">
        <div class="bg-files" (click)="patchLicensePlate(null)"
          [style.background-image]="'url(assets/img/no-image.png)'">
        </div>
      </div>
      <ng-container *ngFor="let plate of licensePlates">
        <div class="position-relative p-3 m-3">
          <div (click)="patchLicensePlate(plate)" style="background-size: contain;" class="bg-files bg-hover"
            [style.background-image]="'url(' + plate.file.thumbnailPath + ')'"></div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<app-add-user #dialogAddUser [applications]="applications" [application]="clientData"
  (formBody)="sendUser($event)"></app-add-user>

<app-modal (close)="onCloseCustomer()" *ngIf="toggleChangeCustomer">
  <div class="modal_container black-text">
    <p class="text-header-modal">Change Customer</p>
    <div #searchContainer [ngClass]="{'active' : showCustomers}" class="div select-bg search-container w-100"
      style="display: block;">
      <input type="text" readonly class="search" style="height: 44px; display: block; width: 100%; padding-left: 12px;"
        (click)="openCustomers()" name="selectedPreset"
        [placeholder]="selectedCustomer ? selectedCustomer.name : 'Select Customer...'">

      <div class="form-group">
        <div class="prikaz" *ngIf="showCustomers">
          <div class="backdrop" (click)="openCustomers()"></div>
          <div style="z-index: 100; overflow-y: auto;">
            <div class="divider"></div>
            <input type="text" class="search-marke" (input)="applyCustomerFilter()"
              [attr.placeholder]="'user.search' | translate" name="searchCustomersParam" name="searchCustomersParam"
              [(ngModel)]="searchCustomersParam">
            <ul style="margin-bottom: 12px;">
              <li *ngFor="let customer of customersSearch"
                (click)="showCustomers=!showCustomers; selectCustomer(customer)">
                {{ customer.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div style="min-height: 100px;"></div>
    <p class="p-2" style="font-size: .93rem;" *ngIf="selectedCustomer">Move to {{selectedCustomer.name}}</p>

    <button style="width: 150px;" (click)="moveClient()" class="custom-button mt-3">SAVE</button>
  </div>
</app-modal>

<app-modal (close)="toggleAddBackground = !toggleAddBackground" *ngIf="toggleAddBackground">
  <div class="modal_container black-text">
    <div class="modal-header">
      <h4 class="modal-title">Add Background</h4>
    </div>
    <div class="modal-body">
      <form #formAddLogo="ngForm">
        <div class="form-group right col-lg-12 col-md-12 ">
          <input type="file" name="image" ngModel (change)="getFiles($event)" placeholder="Choose Image" />
        </div>
        <div class="progress my-3" *ngIf="isUploading">
          <div class="progress-bar progress-bar-info progress-bar-striped progress-bar-animated" role="progressbar"
            attr.aria-valuenow="{{ progress }}" aria-valuemin="0" aria-valuemax="100"
            [ngStyle]="{ width: progress + '%' }">
            {{ progress }}%
          </div>
        </div>
        <button type="button" class="custom-button save-button" (click)="uploadBackground()">Save</button>
      </form>
    </div>
  </div>
</app-modal>

<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Loading...'"></div>
</div>